function hackVantOverflow() {
  try {
    const target = document.body
    const config = { attributes: true }
    const observer = new MutationObserver(() => {
      const classList: string[] = [].slice.call(target.classList)
      if (
        classList.includes('van-overflow-hidden') ||
        classList.includes('van-toast--unclickable')
      ) {
        document.documentElement.style.overflowX = 'unset'
      } else {
        document.documentElement.style.overflowX = ''
      }
    })
    observer.observe(target, config)
  } catch {
  }
}

/**
 * 兼容 wujie 引入的子应用无法被 shadowdom 外的 mouseup 事件触发，
 * 导致一些 el-select 等组件部分场景下无法正确隐藏下拉框的问题
 */
function hackWujieShadowDomEvent() {
  try {
    const TARGET_CLASS_NAME = 'wujie_iframe'

    document.addEventListener('mouseup', (e: Event) => {
      // 针对从 wujie 子应用内冒泡出来的事件不做特殊处理
      // 点击svg的时候，target是没有classname的
      if ((e?.target as Element)?.className?.includes?.(TARGET_CLASS_NAME)) return

      const wujieFrames = [].slice.call(document.querySelectorAll(`.${TARGET_CLASS_NAME}`))
      wujieFrames.forEach((item: Element) => {
        const event = new CustomEvent('mouseup', { bubbles: true })
        item.shadowRoot?.dispatchEvent(event)
      })
    })
  } catch {
  }
}

hackVantOverflow()
hackWujieShadowDomEvent()
